import axios from 'axios';
import CONFIG from '../environments/config';
import AuthService from './auth.service';
import store from '../store';

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const token = error.response.headers[CONFIG.AUTH_HEADER.toLowerCase()];

  switch(error.response.status) {
    case 401:
      store.dispatch('auth/signout').then(() => {
        if(window.vue.$i18n.locale === 'ar') {
        // response.401014.UNAUTHORIZED_TOKEN_NOTEXIST.en=Your session has expired. Please re-login.
        // response.401014.UNAUTHORIZED_TOKEN_NOTEXIST.ar=
          window.alert('مدة استخدام هذه الجلسة انتهت . برجاء إعادة تسجيل الدخول');
        } else {
          window.alert('Your session has expired. Please re-login.');
        }
        window.location.href = "/#/search/keyword-search";
        window.location.reload();
      });
      break;
    default:
      if(token) {
        store.dispatch('auth/setToken', token);
      }
      break;
  }
  return Promise.reject(error);
});

export default class BaseService {

  static config = CONFIG;

  __make_array_param_to_string(value) {
    const s = [];

    const add = (k, v) => {
      v = typeof v === 'function' ? v() : v;
      v = v === null ? '' : v === undefined ? '' : v;
      s.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    };

    const buildParams = (prefix, obj) => {
      if (prefix) {
        if (Array.isArray(obj)) {
          obj.forEach((v, i) => buildParams(prefix + '[' + (typeof v === 'object' && v ? i : '') + ']', v));
        } else if (obj instanceof Date) {
          add(prefix, JSON.stringify(obj));
        // } else if (obj instanceof dayjs) {
        //   add(prefix, (obj as dayjs.Dayjs).toJSON());
        } else if (String(obj) === '[object Object]') {
          Object.keys(obj).forEach((key) => buildParams(prefix + '[' + key + ']', obj[key]));
        } else {
          add(prefix, obj);
        }
      } else if (Array.isArray(obj)) {
        obj.forEach((v) => add(v.name, v.value));
      } else {
        Object.keys(obj).forEach((key) => {
          buildParams(key, obj[key]);
        });
      }
      return s;
    };

    return buildParams(null, value).join('&');
  }

  __header() {
    // const accessToken = store.dispatch('auth/getToken');
    const accessToken = AuthService.getToken();
    const headers =  {
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Credentials': 'true',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    };
  
    if (accessToken) {
      return {
          ...headers,
          [CONFIG.AUTH_HEADER]: accessToken
        }
    } else {
      return headers
    }
  }

  async __request(method, url, params) {
    if (method === 'get' && params) {
      url = url + '?' + this.__make_array_param_to_string(params);
    }

    return await axios.request({
        baseURL: CONFIG.API_BASE_URL,
        url: url,
        method,
        headers: this.__header(),
        data: (method === 'get') ? {} : params,
        withCredentials: true,
    });
  }

  async get(url, params) {
    return await this.__request('get', url, params)
  }

  async post(url, params) {
    return await this.__request('post', url, params)
  }

  async put(url, params) {
    return await this.__request('put', url, params)
  }

  async delete(url, params) {
    return await this.__request('delete', url, params)
    // if (params) {
    //   url = url + '?' + this.__make_array_param_to_string(params);
    // }
    // console.log('aaaa', `[${url}]`);

    // return await axios.delete(url, {
    //   headers: this.__header(),
    //   withCredentials: true,
    // });
        // baseURL: CONFIG.API_BASE_URL,
        // url: url,
        // method,
        // headers: this.__header(),
        // data: (method === 'get') ? {} : params,
    // });
  }

  // downloadExcelFile(data: any, type: string) {
  //   const pom = document.createElement('a');
  //   // const blob = new Blob(['\ufeff', data], { type });
  //   const blob = new Blob([data], { type });
  //   const url = window.URL.createObjectURL(blob);
  //   pom.href = url;
  //   pom.setAttribute('download', dayjs().format('YYYYMMDDHHmmss') + '.xlsx');
  //   pom.click();
  // }

  // protected paginate<T>(
  //   path: string,
  //   params: Params | Pagination,
  //   pagination?: Pagination
  // ): Observable<PaginatedResponse<T>> {
  //   let request = {};
  //   if (params instanceof Pagination) {
  //     request = {
  //       skip: String(params.limit * params.page),
  //       take: String(params.limit),
  //     };
  //   } else {
  //     request = {
  //       ...params,
  //       skip: String(pagination.limit * pagination.page),
  //       take: String(pagination.limit),
  //     };
  //   }
  //   return this.__api<PaginatedResponse<T>>('get', path, request).pipe(
  //     mergeMap((res) => {
  //       res.limit = params.limit || pagination.limit;
  //       res.page = params.page || (pagination ? pagination.page || 0 : 0);
  //       return of(res);
  //     })
  //   );
  // }
}